<div #bodyWrapper>
    <app-bread-crumb [links]="[
    {
      'href': '/developer/my-subscriptions',
      'title': 'My Subscriptions'
    },
    {
        'href': '/developer/view-product/'+this.breadCrumbProductId,
        'title': this.breadCrumbProductName               
    },
    {
        'href':  '/developer/view-my-subscription/'+this.breadCrumbSubscriptionName+'/'+this.breadCrumbProductId,   
        'title': this.breadCrumbSubscriptionDisplayName               
    },
    {
        'href':  '/developer/view-my-subscription/'+this.breadCrumbSubscriptionName+'/'+this.breadCrumbProductId,   
        'title': 'Subscription Details'               
    }
  ]" [buttonProps]="[]" (click)="oncloseToast(true)"></app-bread-crumb>
    <section class="content-section" #contentSection>
        <app-general-loader *ngIf="loaderActive"></app-general-loader>
        <div class="form-section" [class.loading]="loaderActive">
            <div class="container form-head" [class.loading]="loaderActive">
                <div>
                    <h2 class="title">Subscription Details</h2>
                    <p>Please find a detailed overview of all product subscription related information below.</p>
                </div>
            </div>



            <div class="container" id="view" [class.loading]="loaderActive">
                <div class="row">
                    <div class="Toggle-tracing">
                        <div class="col-12 col-sm">
                            <h3 class="title">Subscriber Name</h3>
                            <h3 class="bold title">{{this.dataset.subscriberName}}</h3>
                        </div>
                        <div *ngIf="isStateActive && showToggle">
                            <div class="slider-switch-container">
                                <app-slider-switch [props]="{
                      heading: 'Toggle Tracing',
                      info:'Tracing can be activated for one hour only.',
                      disable: false
                      
                    }" (allowTracingChange)="onAllowTracingChange($event)" [allowTracing]="this.dataset "
                                    [toggleDisabled]="toggleDisabled"></app-slider-switch>
                            </div>
                        </div>
                    </div>
                </div>
                <ng-container *ngIf="this.dataset.subscriptionDisplayName">
                    <div class="row">
                        <div class="col-12 col-sm">
                            <h3 class="title">Subscription Name</h3>
                            <h3 class="title bold" style="display: flex;">
                                {{this.dataset.subscriptionDisplayName}}<app-copy-clipboard class="inherit-text"
                                    [copyTextValue]=this.dataset.subscriptionDisplayName (click)="oncloseToast(true)"></app-copy-clipboard></h3>
                        </div>
                    </div>
                </ng-container>
                <ng-container *ngIf="isStateActive">
                    <div class="row">
                        <div class="col-12 col-sm">
                            <h3 class="title">API Key</h3>
                            <h3 class="title bold"><app-copy-clipboard class="inherit-text"
                                    [copyTextValue]=this.dataset.subscriptionKey (click)="oncloseToast(true)"> <span
                                        class="inherit-text"><app-text-mask [text]="this.dataset.subscriptionKey"
                                            class="inherit-text"></app-text-mask></span></app-copy-clipboard></h3>
                        </div>
                        <div class="col-12 col-sm">
                            <h3 class="title">Product App Registration Id</h3>
                            <h3 class="title bold" style="display: flex;">{{this.dataset.productAppregistrationID}}<a
                                    href="https://portal.azure.com/#view/Microsoft_AAD_RegisteredApps/ApplicationMenuBlade/~/Overview/appId/{{this.dataset.productAppregistrationID}}/isMSAApp~/false"
                                    target="_blank" style="display: flex;padding-left: 2rem;"><img
                                        src="../../../../assets/_target.svg" alt="" class="img-svg-wrapper" (click)="oncloseToast(true)"></a>
                                <app-copy-clipboard class="inherit-text icon-warpper col-12 col-sm"
                                    [copyTextValue]=this.dataset.productAppregistrationID (click)="oncloseToast(true)"></app-copy-clipboard>
                            </h3>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="this.dataset.proxyClientID && isStateActive">
                    <div class="row">
                        <div class="col-12 col-sm">
                            <h3 class="title">Client App Registration Id</h3>
                            <h3 class="title bold" style="display: flex;">{{this.dataset.proxyClientID}}<a
                                    href="https://portal.azure.com/#view/Microsoft_AAD_RegisteredApps/ApplicationMenuBlade/~/Overview/appId/{{this.dataset.proxyClientID}}/isMSAApp~/false"
                                    target="_blank" style="display: flex;padding-left: 2rem;" (click)="oncloseToast(true)"><img
                                        src="../../../../assets/_target.svg" alt="" class="img-svg-wrapper" (click)="oncloseToast(true)"></a>
                                <app-copy-clipboard class="inherit-text" style="padding-left: .7rem;"
                                    [copyTextValue]=this.dataset.proxyClientID (click)="oncloseToast(true)"></app-copy-clipboard>
                            </h3>
                        </div>
                    </div>
                </ng-container>
                <div class="row">
                    <div class="col-12 col-sm-12 col-md-5">
                        <h3 class="title">State</h3>
                        <h3 class="title bold">{{this.dataset.state}}</h3>
                    </div>
                    <div class="col-12 col-sm-12 col-md-5">
                        <h3 class="title">Usage Notes</h3>
                        <h3 class="title bold">{{this.dataset.userNotes}}</h3>
                    </div>
                    <div class="col-12 col-sm-12 col-md-5">
                        <h3 class="title">Remarks</h3>
                        <h2 class="title">{{this.dataset.remarks}}</h2>
                    </div>
                    <div class="col-12 col-sm-12 col-md-12">
                        <h3 class="title">Approvers</h3>
                        <app-render-control-values [value]="this.approverList" [type]="'tag'"
                            [isTagLabel]=true></app-render-control-values>
                    </div>
                </div>
            </div>
            <div class="container subscriptionTable" [class.loading]="loaderActive">
                <div class="col-12 col-sm-12 col-md-5" [class.loading]="loaderActive">
                    <h3 class="title">Product Name</h3>
                    <h2 class="title">{{this.dataset.productName}}</h2>
                </div>
                <div class="table-wrapper">
                    <table>
                        <tr>
                            <th>API Name</th>
                            <th>API Owner</th>
                            <th *ngIf="isStateActive">Actions</th>
                        </tr>
                        <tbody>
                            <ng-container *ngFor="let api of this.dataset.apiData; let i = index">
                                <tr>
                                    <td><a [routerLink]="'/developer/api-definition/'+ api.apimApiName"
                                            class="blue-content"
                                            [queryParams]="{'apiName': api.name, 'productId':this.breadCrumbProductId, 'productName':this.breadCrumbProductName}"
                                            [state]="{parentData: {showSubscriptionLink: true, subscriptionName:this.breadCrumbSubscriptionName}}">{{api.name}}</a>
                                    </td>
                                    <td class="bold-content">{{api.apiOwner}}</td>
                                    <td *ngIf="isStateActive">
                                        <div>
                                            <div class="info-tooltip">
                                                <span [attr.title]="'Download API Definition'">
                                                    <img class="download-wrapper svg-hover-effect"
                                                        src="./assets/buttons/download-white.svg"
                                                        (click)="openModal(api.apimApiName)">
                                                </span>
                                                <div *ngIf="dataset.state === 'Active'">
                                                    <span [attr.title]="'Download API Test File'">
                                                        <img class="download-wrapper img-wrapper-medium svg-hover-effect"
                                                            src="./assets/testIcon.svg"
                                                            (click)="openModalAndDownload(api.apimApiName)">
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
        <div class="info-section container">
            <app-information-section [information]="pageInfo"
                [detailsInfo]="this.detailsInfo"></app-information-section>
        </div>

    </section>
    <app-pop-ups [props]="{
    'content': 'Please choose the preferred file format to describe the API',
    'heading': 'Download API Definition',
    'icon': './assets/buttons/download-white.svg',
    'isIconZoomRequired':false,
    id:'api_def_download',
    radio:[{checked: true, label: 'Open API'},{checked: false, label: 'Swagger'}]
  }" [isRadioButtonNeeded]="true" [control]="downloadOptionControl"
        (downloadConfirmed)="confirmAPIDefDownload($event)"></app-pop-ups>
    <app-pop-ups [props]="{
    'content': 'Please choose the preferred file format to interact with the API',
    'heading': 'Download API Test File',
    'icon': './assets/testIcon.svg',
    'isIconZoomRequired':true,
    id:'test_download',
    radio:[{checked: true, label: 'Visual Studio Code script'},{checked: false, label: 'Postman project', info: this.infoMessagePostmanOption}]
  }" [isRadioButtonNeeded]="true" [control]="downloadTestOptionControl"
        (downloadConfirmed)="confirmDownload($event)"></app-pop-ups>
</div>

<app-alert *ngIf="showSuccess" [success]="true" [manualCloser]="true">
    <div class="success_Icon"><img src="../../../../assets/successIcon.svg" />
        <p>{{successMsg}}</p>
    </div>
</app-alert>
<app-alert *ngIf="showFailure" [failure]="true" [manualCloser]="true" (close)="oncloseToast($event)">
    <div class="unSuccess_Icon"><img src="../../../../assets/Health-monitor/Unhealthy.svg" />
        <p>{{failureMsg}}</p>
    </div>
</app-alert>